import $ from 'jquery'
import './dpMenu'
import lxWrap from '../../common/js/lx'
import lxBid from '../../common/js/lx-bid'

/**
 * 
 * @param {node} trigger 触发节点
 * @param {node} target  目标节点
 * @param {function} setPos  位置回调函数
 */
function hoverShow(trigger, target, activeClass = 'current', hideClass = 'Hide') {

    [trigger, target].forEach(function (item) {

        item.on('mouseenter', function () {
            target.removeClass(hideClass);
            trigger.addClass(activeClass);
        }).on('mouseleave', function () {
            target.addClass(hideClass);
            trigger.removeClass(activeClass);
        });
    });
}

const cateNav = {
    init: (config) => { 
        // 搜索页 频道导航栏收起的逻辑
        let $head = $('.J-all-cate'),
            $cateMain = $('.J-cate-nav')
        if (config.isSearchPage) {
            hoverShow($head, $cateMain)
        }else if(config.isChannelPage) {
            let $navHeader = $('#cate-channel .nav-header')
            // 默认是收起的，有fixed则展开
            let $channelContainer = $('.J-cate-nav')
            if (!$navHeader.hasClass('J-cate-fixed')) { // 收起
                hoverShow($head, $cateMain)
            } else { // 展开
                if ($channelContainer.hasClass('Hide')) {
                    $channelContainer.removeClass('Hide')
                }
             }
        }
        
        // $primaryItems = $primaryMenu.find('.first-item');
        const $primaryMenu = $('.J-primary-menu');
        
        $primaryMenu.click(function (event) {
            event.stopPropagation();
        });
        $primaryMenu.dpMenu({
            activate: activateSubmenu,
            deactivate: deactivateSubmenu
        });
        // 全部分类
        lxWrap($('.all-cate'), lxBid.allCateBid, false, false, false)
        // 横向导航点击
        lxWrap($('.sec-cate a'), lxBid.moreCataBid, true, false)
        // 主导航点击
        lxWrap($('.primary-container a'), lxBid.mainCateBid, true, false)
        // 扩展导航点击
        lxWrap($('.nav-header .other-cate'), lxBid.rowCateBid, true, false)
        /**
         * 展开二级导航
         * @param {*} row 
         */
        function activateSubmenu(row) {
            let $row = $(row),
                $secCate = $row.find('.sec-cate');
            $row.addClass('active');
            // 没有数据，无需展开
            if ($secCate.data('extend') != '0') {
                $secCate.removeClass('Hide');
            }
            // 扩展导航曝光点
            lxWrap($secCate, lxBid.extendNavBid, true, true)
        }
        /**
         * 收起二级导航
         * @param {*} row 
         */
        function deactivateSubmenu(row) {
            let $row = $(row);
            if ($row.hasClass('active')) {

                $row.removeClass('active');

            }
            $row.find('.sec-cate').addClass('Hide');
        }
    }
}

export default cateNav;


// WEBPACK FOOTER //
// ./modules/cate-nav-index/js/cate-nav.js